export interface NavLink {
  key: 'services' | 'process' | 'about';
  href: string;
}

export const navLinks: NavLink[] = [
  { key: 'services', href: '#services' },
  { key: 'process', href: '#process' },
  { key: 'about', href: '#about' },
];
